<template>
    <div>
        <v-layout row wrap align-center justify-center>
              <v-flex xs12 sm7 md7>
                  <dialogos-app :dialogos="dialogosB" tucan="0"></dialogos-app>
              </v-flex>
        </v-layout>
        <v-layout row wrap justify-center align-center>
            <v-flex xs12 sm7 md7 mt-2 mb-2>
                <h2 class="titulo-descripcion">Expressões {{countVistos}} / 13</h2>
            </v-flex>
            <v-flex xs12 sm7 md7 >
                <ul>
                    <li>Um dia de trabalho do guarda de trânsito Alberto...</li>
                    <li>—<span :class="{'btninactive':!inactive[6] , 'word-active':wordActive[6]}" @click="wordAction(6)"> Bom dia,</span> seu guarda.</li>
                    <li>— Bom dia, moça. <span :class="{'btninactive':!inactive[0] , 'word-active':wordActive[0]}" @click="wordAction(0)">Pois não</span>, em que eu poderia ajudar?</li>
                    <li>— <span :class="{'btninactive':!inactive[1] , 'word-active':wordActive[1]}" @click="wordAction(1)">O senhor poderia</span> me informar onde fica a rua Barata Ribeiro?</li>
                    <li>— <span :class="{'btninactive':!inactive[2] , 'word-active':wordActive[2]}" @click="wordAction(2)">Sim, com muito prazer.</span> Siga dois quarteirões em frente e depois vire na primeira rua à direita. Você me entendeu?</li>
                    <li>— <span :class="{'btninactive':!inactive[3] , 'word-active':wordActive[3]}" @click="wordAction(3)">Sim, senhor. Muito obrigada.</span></li>
                    <li>— <span :class="{'btninactive':!inactive[4] , 'word-active':wordActive[4]}" @click="wordAction(4)">De nada.</span></li>
                    <li>Depois de uma hora, chega uma senhora e pede informação.</li>
                    <li>— <span :class="{'btninactive':!inactive[5] , 'word-active':wordActive[5]}" @click="wordAction(5)">Com licença</span>, seu guarda.</li>
                    <li>— Bom dia. <span :class="{'btninactive':!inactive[7] , 'word-active':wordActive[7]}" @click="wordAction(7)"> Às suas ordens,</span> senhora. Em que posso ser útil?</li>
                    <li>- O senhor sabe onde ficam as Lojas Americanas?</li>
                    <li>— Claro que sim. A senhora segue dois quarteirões, vira à direita, depois vira na 4ª rua à esquerda...</li>
                    <li>— <span :class="{'btninactive':!inactive[8] , 'word-active':wordActive[8]}" @click="wordAction(8)">Desculpe</span>, não estou entendendo. O senhor poderia repetir?</li>
                    <li>— Posso. A senhora segue dois quarteirões em frente. Na esquina, vira à direita, encontra o Ibirapuera e depois vira à esquerda.</li>
                    <li>— <span :class="{'btninactive':!inactive[9] , 'word-active':wordActive[9]}" @click="wordAction(9)">Por favor</span>, não entendo. Ibi... o quê? O</li>
                    <li>I – B – I – R – A – P – U – E – R – A.</li>
                    <li>Ok.</li>
                    <li><span :class="{'btninactive':!inactive[10] , 'word-active':wordActive[10]}" @click="wordAction(10)">Eu ainda tenho uma dúvida.</span> É o shopping que fica perto da avenida?</li>
                    <li>É sim.</li>
                    <li><span :class="{'btninactive':!inactive[11] , 'word-active':wordActive[11]}" @click="wordAction(11)">Muito obrigada.</span></li>
                    <li><span :class="{'btninactive':!inactive[12] , 'word-active':wordActive[12]}" @click="wordAction(12)">Não há de quê.</span></li>
                    <li>O guarda Alberto continua trabalhando e, no finalzinho do dia, ajuda um adolescente a encontrar um endereço...</li>
                </ul>
            </v-flex>
        </v-layout>        
    </div>
</template>

<script>
export default {
    data(){
        return {
            dialogosB:[
                'Descubra as 13 expressões cotidianas e clique nelas para destacá-las.'
            ],
            wordActive:Array(13).fill(false),
            inactive:Array(13).fill(true),
            countVistos:0
        }
    },
    methods: {
        wordAction(val){
            this.$set(this.wordActive,val,true)
            this.$set(this.inactive,val,false)
            this.countVistos += 1
            var todasWordVistos = this.wordActive.every(el => {return el})
            if(todasWordVistos){
                this.$emit('todosVistosSlide')
            }
        }
    },
}
</script>

<style lang="scss" scoped>
@import '../../../sass/globals';
.cont-texto{
    text-align: left;
}
ul{
    list-style: none;
    padding: 0;
    margin: 0;
    text-align: left;
    font-family: Poppins-Regular;
    font-size: 13px;
    li{
        span{
            transition: all 0.3s ease-out;
        }
    }
}
.word-active{
    color: #BF0810;
}
.titulo-descripcion{
  font-family: Poppins-Italic;
  font-size: 13px;
}
.btninactive{
    pointer-events: none;
}

</style>